import { Divider, FormControl, FormLabel, Select } from '@chakra-ui/react';

import { EDigestPreference } from '@/graphql-types/globalTypes';
import { DIGEST_PREFERENCE_OPTIONS } from '@/imports/ui/components/shared/util';

export const LinkDigestPrefListItem: React.FC<{
  link:
    | {
        _id: string;
        digestPreference?: EDigestPreference | null;
        organization: {
          name: string;
          defaultDigestPref: EDigestPreference;
        };
      }
    | {
        _id: string;
        digestPreference?: EDigestPreference | null;
        group: {
          name: string;
          settings: { defaultDigestPref: EDigestPreference };
        };
      };
  onChange: (
    options:
      | {
          userGroupLinkId: string;
          pref: EDigestPreference;
        }
      | {
          userOrganizationLinkId: string;
          pref: EDigestPreference;
        }
  ) => void;
  isDisabled: boolean;
  isLast?: boolean;
}> = (props) => {
  const link = props.link;
  const groupOrOrg = 'organization' in link ? link.organization : link.group;
  const defaultPref =
    'organization' in link
      ? link.organization.defaultDigestPref
      : link.group.settings.defaultDigestPref;
  const effectivePref = link.digestPreference
    ? link.digestPreference
    : defaultPref;
  const handleSetPref = (linkId: string, pref: EDigestPreference): void => {
    'organization' in link
      ? props.onChange({ userOrganizationLinkId: linkId, pref })
      : props.onChange({ userGroupLinkId: linkId, pref });
  };
  return (
    <>
    <FormControl
      display="flex"
      alignItems="center"
      isDisabled={props.isDisabled}
      px="4"
    >
      <FormLabel mb="0" flex="1" color="textPrimary.500" _disabled={{ color: "textPrimary.500", opacity: 1 }}>
        {groupOrOrg.name}
      </FormLabel>
      <Select
        maxW="150px"
        borderRadius={"md"}
        size="sm"
        value={effectivePref}
        aria-label={`${groupOrOrg.name} digest preference`}
        onChange={(event) =>
          handleSetPref(link._id, event.target.value as EDigestPreference)
        }
      >
        {DIGEST_PREFERENCE_OPTIONS.map((digestPreferenceOption) => (
          <option
            key={digestPreferenceOption.value}
            value={digestPreferenceOption.value}
          >
            {digestPreferenceOption.text}
          </option>
        ))}
      </Select>
    </FormControl>
      {!props.isLast && (
        <Divider border="1px solid" borderColor="secondary.500" mt="0" />
      )}
    </>
  );
};
